import type { AzureUserInfo } from '@/auth/azure/azureManager'
import { Roles } from '@/auth/azure/Roles'
import { isUserRoleAllowed } from '@/routes/utils'

type OrderAssignmentPermissionsOptions = {
  userInfo?: AzureUserInfo
  assigneeEmail?: string | null
  creating?: boolean
}

export const getOrderAssignmentPermissions = ({
  userInfo,
  assigneeEmail,
  creating = false,
}: OrderAssignmentPermissionsOptions) => {
  const canManageOrderAssignments =
    isUserRoleAllowed(userInfo?.roles, [Roles.GlobalAdministrator, Roles.Supervisor]) ||
    (userInfo?.roles?.hasRole(Roles.Administrator) === true && userInfo.roles.hasRole(Roles.Organizer))
  const canAssignOrderToSelf = isUserRoleAllowed(userInfo?.roles, [
    Roles.GlobalAdministrator,
    Roles.Supervisor,
    Roles.Organizer,
  ])
  const normalizedAssigneeEmail = assigneeEmail?.toLowerCase()
  const normalizedUserEmail = userInfo?.email?.toLowerCase()
  const isAssignedToCurrentOrganizer =
    userInfo?.roles?.hasRole(Roles.Organizer) === true &&
    normalizedAssigneeEmail !== undefined &&
    normalizedAssigneeEmail === normalizedUserEmail

  return {
    canAssignOrderToOthers: !creating && canManageOrderAssignments,
    canAssignOrderToSelf: !creating && canAssignOrderToSelf,
    canRemoveOrderAssignment: !creating && (canManageOrderAssignments || isAssignedToCurrentOrganizer),
  }
}
